<div class="next-aztec-scanner">

  <div class="next-aztec-scanner__title"
      [innerHTML]="getTranslationKey('TITLE') | translate | safeHtml">
  </div>

  <div class="next-aztec-scanner__scanner">

    <div [id]="aztecScannerService.CAMERA_CONTAINER_ID"
         class="next-aztec-scanner__scanner__camera">
    </div>
  </div>

  <div class="next-aztec-scanner__buttons">
    <button class="btn btn--outline"
            (click)="cancel()">
      {{ getTranslationKey('CANCEL') | translate }}
    </button>

<!--    <button class="btn btn&#45;&#45;outline"-->
<!--            (click)="mock()">-->
<!--      Mock-->
<!--    </button>-->
  </div>
</div>
